<template>
    <!-- 票台管理 － 新增票台 -->
    <content-view>
        <div class="wrap-container-in">
            <a-form :form="form" class="desk-ticket-form" @submit="handleSubmit">
                <a-form-item label="票台名称：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入" v-decorator="['name',{rules: [{required: true, message: '请输入票台名称',}]}]"></a-input>
                </a-form-item>
                <a-form-item label="票台账号：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入" v-decorator="['account',{rules: [{required: true, message: '请输入票台账号',}]}]"></a-input>
                </a-form-item>
                <a-form-item label="票台密码：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入" v-decorator="['password',{rules: [{required: true, message: '请输入票台密码',}]}]"></a-input>
                </a-form-item>
                <a-form-item label="是否绑定零售仓库：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-radio-group name="payMode" @change="changeBindStorage" v-decorator="['isBindWarehouse', {rules: [{required: true}], initialValue: 1}]">
                        <a-radio :value="1">是</a-radio>
                        <a-radio :value="0">否</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item v-if="isBindWarehouse" label="仓库绑定：" :label-col="labelCol" :wrapper-col="wrapperCol">
                    <a-select
                    :options="wareHouseList"
                    v-decorator="['warehouseId',{rules: [{ required: true, message: '请选择仓库'}]}]"
                    placeholder="请选择"
                    >
                    </a-select>
                </a-form-item>
                <a-form-item class="text-center">
                    <a-button @click="$router.go(-1)">取消</a-button>
                    <a-button :loading="S_loading_submit" class="mr8" type="primary" html-type="submit">保存</a-button>
                </a-form-item>
            </a-form>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    import { mapGetters } from 'vuex';
    export default {
        name: "adddeskTicket",
        components: {},
        props: {},
        data() {
            return {
                labelCol: {span: 8},
                wrapperCol: {span: 10},
                id: undefined,
                S_loading_submit: false,
                wareHouseList: [],
                isBindWarehouse: 1,
            };
        },
        computed: {
            ...mapGetters(['shopId']),
            ...mapGetters(['shopName']),
        },
        watch: {
            shopId() {
                this.getWarehouseList();
            }
        },
        methods: {
            changeBindStorage({target}) {
                this.isBindWarehouse = target.value;
            },
            getWarehouseList() {
                if (!this.shopId) return;
                this.$api.ticketDesk.getWarehouseList({
                    query: {
                        shopId: this.shopId,
                        counterId: this.id
                    }
                }).then(res => {
                    res.forEach(item => {
                        item.label = item.warehouseName;
                        item.value = item.id;
                    });
                    this.wareHouseList = res;
                });
            },
            getDetail() {
                this.$api.ticketDesk.cashPayPlatformInfo({
                    params: {
                        id: this.id
                    }
                }).then(res => {
                    let { name, account, isBindWarehouse, warehouseId, password } = res;
                    this.isBindWarehouse = Number(isBindWarehouse);
                    let formValues = {
                        name,
                        account,
                        isBindWarehouse: Number(isBindWarehouse),
                        password
                    }
                    if (isBindWarehouse) {
                        formValues.warehouseId = warehouseId;
                    }
                    this.form.setFieldsValue(formValues);
                });
            },
            handleSubmit(e) {
                e.preventDefault();
                this.form.validateFields((err, values) => {
                    if (!err) {
                        if (values.warehouseId) {
                            let currentWarehouseItem = this.wareHouseList.find( i => {
                                return i.id == values.warehouseId
                            });
                            if (Boolean(currentWarehouseItem)) {
                                values.warehouseName = currentWarehouseItem.warehouseName;
                            } else {
                                this.$message.error('该仓库不存在，请重新选择！');
                                return false;
                            }
                        }
                        this.S_loading_submit = true;
                        this.$api.ticketDesk[this.routeName === 'updateCashierDesk' ? 'updateCounter' : 'addCounter']({
                            body: {
                                ...values,
                                id: this.id,
                                shopId: this.shopId,
                                shopName: this.shopName
                            }
                        }).then(res => {
                            this.$message.success('操作成功', 2)
                            this.$router.go(-1)
                            this.S_loading_submit = false
                        }).catch(res => {
                            this.S_loading_submit = false;
                        });
                    }
                });
            },

        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.id = this.$route.params.id;
            this.routeName = this.$route.name;
            if(this.routeName === 'updateCashierDesk') { // 编辑
                this.getDetail();
            };
            this.getWarehouseList();
        }
    };
</script>
<style lang="scss" scoped>
    .desk-ticket-form {
        .ant-input-number,
        .ant-calendar-picker {
            width: 100%;
        }
    }
</style>